import { api } from "../../services/Api.js";

export function get_news({ commit, state }, payload ){
      
   
    // adding token
    payload.token=state.appSettings.token
    
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
     // return chainable promise
      return  api.post(school,"get_news.php",payload).then( result =>{
            
            // the key to add news list to news array
            var a=payload.id.toString();
            var b=(payload.feed) ? payload.feed : "featured"
            var store_key=(a+b).toString();
            
            //alert("storekey"+store_key);
            commit('SET_NEWS', {key:store_key,news:result.data});
            
            return result;
          })
          .catch( error => {
            //console.log("ERROR GETTING NEWS",error);
            //commit('LOADED',true);
            return error;
          })
    
    
  }